export default "__VITE_ASSET__Cujjzrj8__"